import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'

const TecSExpertiseMain = () => {

  useEffect(()=>{
    

    document.getElementById('tec-sectionMainA').style.display = "none";
    document.getElementById('tec-sectionMainB').style.display = "none";
  setTimeout(()=>{
    document.getElementById('tec-lableMainA').style.position="static"  
    document.getElementById('tec-lableMainB').style.position="static"
    document.getElementById('tec-lableMainC').style.position="static"  
    document.getElementById('tec-lableMainD').style.position="static" 
    document.getElementById('tec-lableMainE').style.position="static"   
    document.getElementById('tec-lableMainF').style.position="static"  
    document.getElementById('tec-lableMainG').style.position="static" 
    document.getElementById('tec-lableMainH').style.position="static"   
    document.getElementById('tec-lableMainI').style.position="static" 
    document.getElementById('tec-lableMainJ').style.position="static"  
   
    document.getElementById('tec-sectionMainA').style.display = "block";
    document.getElementById('tec-sectionMainB').style.display = "block";



  },1000)

 

   
  
},[])
  return (
    <div className='tec-addmain'>
      
      
   
    <div className="tec-addgrid-layout">
<div className="tec-addmain-top">

<p><span id="tectopspan"><span id="TecTitleMain">EXPERTISE</span></span>
<div className='tec-addmain-back'>
<Link to="/Tecsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div>
</p> 

{/* <hr></hr> */}
</div>
</div>    

<div id="tecscroll">
<ul id="tecLableSectionA">
<li className="tecdot tecdottyExpertise1"id="tec-lableMainA"></li>
<li className="tecdot tecdottyExpertise2" id="tec-lableMainB"></li>
<li className="tecdot tecdottyExpertise3" id="tec-lableMainC"></li>
<li className="tecdot tecdottyExpertise4" id="tec-lableMainD"></li>
<li className="tecdot tecdottyExpertise5"id="tec-lableMainE"></li>
</ul>
<ul id="tecLableSectionB">
<li className="tecdot tecdottyExpertise6" id="tec-lableMainF"></li>
<li className="tecdot tecdottyExpertise7" id="tec-lableMainG"></li>
<li className="tecdot tecdottyExpertise8" id="tec-lableMainH"></li>
<li className="tecdot tecdottyExpertise9" id="tec-lableMainI"></li>
<li className="tecdot tecdottyExpertise10" id="tec-lableMainJ"></li>

</ul>
<ul id='tec-sectionMainA'>

<li className='tectitle1 tectitle-animate' id="tec-touchMainA"><Link to="/TecMobile">  Mobile Application Development</Link></li>
<li className='tectitle2 tectitle-animate'  id="tec-touchMainB"><Link to="/TecWeb">  Web Application and Website Development</Link></li>
<li className='tectitle3 tectitle-animate'  id="tec-touchMainC"><Link to="/TecCloud">  Cloud Computing</Link></li>
<li className='tectitle4 tectitle-animate'  id="tec-touchMainD"><Link to="/TecData">  Data Migration</Link></li>
<li className='tectitle5 tectitle-animate' id="tec-touchMainE"><Link to="/TecBusiness"> Business Intelligence & Analytics</Link></li>
</ul>
<ul id='tec-sectionMainB'>
<li className='tectitle6 tectitle-animate'  id="tec-touchMainF"><Link to="/TecDigital"> Digital Marketing</Link></li>
<li className='tectitle7 tectitle-animate'  id="tec-touchMainG"><Link to="/TecQuality"> Quality Assurance</Link></li>
<li className='tectitle8 tectitle-animate'  id="tec-touchMainH"><Link to="/TecServices">Application Services and Modernization </Link></li>
<li className='tectitle9 tectitle-animate'  id="tec-touchMainI"><Link to="/TecITES">   ITES</Link></li>
<li className='tectitle10 tectitle-animate'  id="tec-touchMainJ"><Link to="/TecStaff"> Staff Augmentation </Link></li>

</ul>
</div>




   </div>
  )
}

export default TecSExpertiseMain
